module.exports = __webpack_public_path__ + "static/img/logoFundacion.c2ad82f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgabout/logoFundacion.jpg
// module id = Bt9Z
// module chunks = 1